
<template>
  <naj-box :title="locales.sectionTitle">
    <v-row>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.number"
          :label="locales.judgementCode"
          :value.sync="formModel.judgementCode"
          :validates="validation"
          :disabled="isBtnChecking || viewMode"
          @input="judgementCodeChanged"
        ></naj-input>
      </v-col>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.number"
          :label="locales.caseCode"
          :value.sync="formModel.caseCode"
          :validates="validation"
          :disabled="isBtnChecking || viewMode"
        ></naj-input>
      </v-col>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.text"
          :label="locales.identityNumber"
          :value.sync="formModel.identityNumber"
          validates="required"
          :disabled="isBtnChecking || viewMode"
        ></naj-input>
      </v-col>
      <v-col
        v-if="!formModel.isJudgementDocumentRetrieved"
        cols="3"
        align-self="center"
        class="text-right"
      >
        <naj-button
          square
          :loading="isBtnChecking"
          :disabled="isCheckBtnDisabled"
          @click="check"
        >
          {{ local.personInformation.check }}
        </naj-button>
      </v-col>
      <v-col
        v-else
        cols="3"
      >
        <naj-error-text
          :text="formModel.confirmationTxt"
          size="medium"
          no-margin
        ></naj-error-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <naj-input
          :type-id="formFieldType.text"
          :label="locales.courtName"
          :value.sync="formModel.courtName"
          :disabled="true"
        ></naj-input>
      </v-col>
      <v-col cols="6">
        <naj-input
          :type-id="formFieldType.text"
          :label="locales.subCircleName"
          :value.sync="formModel.subCircleName"
          :disabled="true"
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapState } = createNamespacedHelpers('LawsuitModule');
import { attachmentCategory } from '@/helpers/enum.js';
export default {
  inject: ['$validator'],
  name: 'JudgementDocument',
  props: {
    validates: {
      type: Object,
      default: () => ({}),
    },
    formModel: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return { isBtnChecking: false };
  },
  computed: {
    ...mapState({ attachmentsData: state => state.attachments.data }),
    locales() {
      return this.local.dynamicFormAdmin.customComponents.judgementDocument;
    },
    isCheckBtnDisabled() {
      return ((!this.formModel.judgementCode || !this.formModel.caseCode || !this.formModel.identityNumber || this.isBtnChecking));
    },
    isVerified() {
      return this.formModel.isJudgementDocumentRetrieved;
    },
    validation() {
      return {
        long: true,
        max: 10,
        isVerified: this.isVerified,
        ...this.validates,
      };

    },
  },
  watch: {
    'formModel.judgementCode'(newVal, oldVal) {
      if (newVal != oldVal)
        this.$set(this.formModel, 'isJudgementDocumentRetrieved', false);
    },
    'formModel.caseCode'(newVal, oldVal) {
      if (newVal != oldVal)
        this.$set(this.formModel, 'isJudgementDocumentRetrieved', false);
    },
    'formModel.identityNumber'(newVal, oldVal) {
      if (newVal != oldVal)
        this.$set(this.formModel, 'isJudgementDocumentRetrieved', false);
    },
  },
  methods: {
    ...mapActions(['getJudgementDocumentByCodeCaseCodePartyIdentity', 'deleteAttachment']),
    resetForm() {
      this.$set(this.formModel, 'courtName', null);
      this.$set(this.formModel, 'subCircleName', null);
      this.$set(this.formModel, 'isJudgementDocumentRetrieved', false);
    },
    judgementCodeChanged(value) {
      if (!value) {
        const filteredJudgementFiles = Object.values(this.attachmentsData)
          .filter(c => c.category === attachmentCategory.judgementImage && c.isAttachmentAudited);
        if (filteredJudgementFiles && filteredJudgementFiles.length > 0)
          filteredJudgementFiles.forEach((filteredJudgement) => {
            this.deleteAttachment({
              objectKey: filteredJudgement.objectKey,
              attachmentKey: filteredJudgement.objectKey,
            });
          });
        this.resetForm();
      }
    },
    check() {
      this.$nextTick(() => {
        this.isBtnChecking = true;
        this.$set(this.formModel, 'isJudgementDocumentRetrieved', false);
        this.getJudgementDocumentByCodeCaseCodePartyIdentity(this.formModel)
          .then((res) => {
            this.toaster.success(res.status);
            this.$set(this.formModel, 'confirmationTxt', res.status);
            this.$set(this.formModel, 'courtName', res.courtName);
            this.$set(this.formModel, 'subCircleName', res.subCircleName);
            this.$set(this.formModel, 'isJudgementDocumentRetrieved', true);
          })
          .catch((err) => {
            this.toaster.error(err);
            this.$set(this.formModel, 'courtName', '');
            this.$set(this.formModel, 'subCircleName', '');
            this.$set(this.formModel, 'isJudgementDocumentRetrieved', false);
          })
          .finally(() => {
            this.isBtnChecking = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
